import React from 'react';
import { Button } from '../components/UI/Button';
import { Users, Lightbulb, Bot, Video, Calendar, FileText, UserPlus, Globe, Award, Clock, Check, AlertTriangle, MessageSquare } from 'lucide-react';
export const Membership = () => {
  return <div className="pt-20 bg-white" data-id="element-2001">
      {/* Hero Section */}
      <section className="relative py-20 border-b border-gray-200" data-id="element-2002">
        <div className="absolute inset-0 z-0" data-id="element-2003">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bNxF5qHdCS6UJLX4hcirCA/IMG_7209.jpg" alt="The Networking Salon" className="w-full h-full object-cover grayscale" data-id="element-2004" />
          <div className="absolute inset-0 bg-black bg-opacity-50" data-id="element-2005"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-2006">
          <div className="max-w-3xl mx-auto text-center" data-id="element-2007">
            <div className="inline-block bg-white text-gray-800 px-4 py-1 rounded-full text-sm font-bold mb-6" data-id="element-2008">
              LIMITED TIME OFFER
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6" data-id="element-2009">
              The Inner Circle Membership
            </h1>
            <p className="text-xl text-gray-200 mb-8" data-id="element-2010">
              Join The Networking Salon Inner Circle — a curated community of
              ambitious professionals. Build meaningful relationships, polish
              your ideas, and unlock opportunities.
            </p>
            <Button className="text-lg px-8 py-4" data-id="element-2011">
              Join Today for ₦20,000 (Founder's Offer)
            </Button>
          </div>
        </div>
      </section>
      {/* Announcement Section */}
      <section className="py-16 bg-gray-50 border-b border-gray-200" data-id="element-2012">
        <div className="container mx-auto px-4" data-id="element-2013">
          <div className="max-w-3xl mx-auto border-2 border-dashed border-gray-400 rounded-lg p-8 text-center" data-id="element-2014">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6" data-id="element-2015">
              Special Founder's Offer
            </h2>
            <div className="flex flex-col md:flex-row justify-center gap-8 mb-6" data-id="element-2016">
              <div data-id="element-2017">
                <p className="text-lg text-gray-600 mb-2" data-id="element-2018">Regular Price:</p>
                <p className="text-3xl font-bold text-gray-800" data-id="element-2019">₦50,000/year</p>
              </div>
              <div className="md:border-l md:border-gray-300 md:pl-8" data-id="element-2020">
                <p className="text-lg text-gray-600 mb-2" data-id="element-2021">Founder's Offer:</p>
                <p className="text-3xl font-bold text-gray-800" data-id="element-2022">₦20,000/year</p>
                <p className="text-gray-600 italic" data-id="element-2023">(until Dec 31 only)</p>
              </div>
            </div>
            <div className="bg-gray-100 p-4 rounded-lg" data-id="element-2024">
              <p className="text-gray-700" data-id="element-2025">
                Subscriptions officially begin Jan 1, 2025 — join now and get
                December free.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Benefits Section */}
      <section className="py-16 border-b border-gray-200" data-id="element-2026">
        <div className="container mx-auto px-4" data-id="element-2027">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12" data-id="element-2028">
            Membership Benefits
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto" data-id="element-2029">
            {[{
            title: 'Mastermind Sessions',
            description: 'Live idea feedback & strategy polishing',
            icon: <Lightbulb size={24} data-id="element-2030" />
          }, {
            title: 'Project Handholding',
            description: 'Step-by-step guidance',
            icon: <Users size={24} data-id="element-2031" />
          }, {
            title: 'AI Tools Catalogue',
            description: 'Curated tools + playbooks',
            icon: <Bot size={24} data-id="element-2032" />
          }, {
            title: 'Virtual Networking Salons',
            description: 'Free & unlimited for members',
            icon: <Video size={24} data-id="element-2033" />
          }, {
            title: 'Discounted Access to Live Events',
            description: 'Special pricing for Inner Circle members',
            icon: <Calendar size={24} data-id="element-2034" />
          }, {
            title: 'Exclusive Resource Hub',
            description: 'Templates & toolkits',
            icon: <FileText size={24} data-id="element-2035" />
          }, {
            title: 'Mentorship & Expert Access',
            description: 'Group coaching & hot-seat sessions',
            icon: <UserPlus size={24} data-id="element-2036" />
          }, {
            title: 'Visibility & Collaboration Opportunities',
            description: 'Connect with other members',
            icon: <Globe size={24} data-id="element-2037" />
          }].map((benefit, index) => <div key={index} className="border-2 border-gray-300 rounded-lg p-6 flex flex-col items-center text-center" data-id="element-2038">
                <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mb-4" data-id="element-2039">
                  {benefit.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-2040">
                  {benefit.title}
                </h3>
                <p className="text-gray-600" data-id="element-2041">{benefit.description}</p>
              </div>)}
          </div>
        </div>
      </section>
      {/* Community Structure */}
      <section className="py-16 bg-gray-50 border-b border-gray-200" data-id="element-2042">
        <div className="container mx-auto px-4" data-id="element-2043">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12" data-id="element-2044">
            Event & Community Structure
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-2045">
            <div className="border-2 border-gray-300 rounded-lg p-6" data-id="element-2046">
              <div className="flex items-center mb-4" data-id="element-2047">
                <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mr-4" data-id="element-2048">
                  <MessageSquare size={24} data-id="element-2049" />
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-2050">
                  WhatsApp Groups
                </h3>
              </div>
              <div className="border-l-2 border-gray-300 pl-4 ml-6" data-id="element-2051">
                <p className="text-gray-600 mb-4" data-id="element-2052">
                  Reserved exclusively for physical event attendees only.
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2" data-id="element-2053">
                  <li data-id="element-2054">Event-specific discussions</li>
                  <li data-id="element-2055">Limited-time access</li>
                  <li data-id="element-2056">City-based connections</li>
                </ul>
              </div>
            </div>
            <div className="border-2 border-gray-300 rounded-lg p-6" data-id="element-2057">
              <div className="flex items-center mb-4" data-id="element-2058">
                <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mr-4" data-id="element-2059">
                  <Users size={24} data-id="element-2060" />
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-2061">
                  Inner Circle Membership
                </h3>
              </div>
              <div className="border-l-2 border-gray-300 pl-4 ml-6" data-id="element-2062">
                <p className="text-gray-600 mb-4" data-id="element-2063">
                  Ongoing access to our premium community resources.
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2" data-id="element-2064">
                  <li data-id="element-2065">Regular masterminds</li>
                  <li data-id="element-2066">Virtual salons</li>
                  <li data-id="element-2067">Exclusive resources</li>
                  <li data-id="element-2068">Ongoing opportunities</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Lifetime Access */}
      <section className="py-16 border-b border-gray-200" data-id="element-2069">
        <div className="container mx-auto px-4" data-id="element-2070">
          <div className="max-w-3xl mx-auto border-2 border-gray-300 rounded-lg p-8" data-id="element-2071">
            <div className="flex items-center justify-center mb-6" data-id="element-2072">
              <Award size={36} className="text-gray-700 mr-3" data-id="element-2073" />
              <h2 className="text-2xl md:text-3xl font-bold text-gray-800" data-id="element-2074">
                Lifetime Access Notice
              </h2>
            </div>
            <p className="text-gray-600 text-lg text-center mb-6" data-id="element-2075">
              As a thank-you, everyone who has ever paid for past Networking
              Salon events now has Lifetime Inner Circle Access — which includes
              all membership benefits (masterminds, resources, AI tools, and
              virtual salons).
            </p>
            <div className="flex items-start bg-gray-100 p-4 rounded-lg border border-gray-300" data-id="element-2076">
              <AlertTriangle size={24} className="text-gray-700 mr-3 mt-1 flex-shrink-0" data-id="element-2077" />
              <p className="text-gray-700" data-id="element-2078">
                <span className="font-bold" data-id="element-2079">Clarification:</span> Lifetime
                Access does not include free entry to Live physical events.
                Tickets must still be purchased separately.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Pricing Section */}
      <section className="py-16 border-b border-gray-200" data-id="element-2080">
        <div className="container mx-auto px-4" data-id="element-2081">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12" data-id="element-2082">
            Choose Your Membership
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-2083">
            {/* Lifetime Inner Circle Access */}
            <div className="border-2 border-gray-300 rounded-lg p-6 relative" data-id="element-2084">
              <div className="absolute top-0 right-0 bg-gray-800 text-white px-3 py-1 text-sm font-bold rounded-bl-lg" data-id="element-2085">
                EXCLUSIVE
              </div>
              <div className="flex justify-center mb-6" data-id="element-2086">
                <div className="w-16 h-16 border-2 border-gray-400 rounded-full flex items-center justify-center" data-id="element-2087">
                  <Award size={32} className="text-gray-700" data-id="element-2088" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-center text-gray-800 mb-2" data-id="element-2089">
                Lifetime Inner Circle Access
              </h3>
              <p className="text-center text-gray-600 mb-6" data-id="element-2090">
                💎 Exclusive for Past Event Attendees
              </p>
              <div className="border-t border-b border-gray-300 py-4 mb-6" data-id="element-2091">
                <p className="text-center text-gray-700 font-medium" data-id="element-2092">
                  One-time gift for loyalty
                </p>
              </div>
              <ul className="space-y-3 mb-8" data-id="element-2093">
                <li className="flex items-start" data-id="element-2094">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-2095" />
                  <span className="text-gray-600" data-id="element-2096">
                    All Inner Circle membership benefits
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2097">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-2098" />
                  <span className="text-gray-600" data-id="element-2099">Masterminds & resources</span>
                </li>
                <li className="flex items-start" data-id="element-2100">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-2101" />
                  <span className="text-gray-600" data-id="element-2102">
                    AI tools & virtual salons
                  </span>
                </li>
                <li className="flex items-start text-gray-700 bg-gray-100 p-2 rounded" data-id="element-2103">
                  <AlertTriangle size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-2104" />
                  <span data-id="element-2105">
                    Does NOT include free entry to Live physical events
                  </span>
                </li>
              </ul>
              <div className="bg-gray-200 text-center p-3 rounded-lg mb-6" data-id="element-2106">
                <span className="font-bold text-gray-700" data-id="element-2107">
                  You're Already In!
                </span>
              </div>
              <Button variant="outline" className="w-full" data-id="element-2108">
                Already a Lifetime Member? Claim Your Access
              </Button>
            </div>
            {/* Founder's Offer */}
            <div className="border-2 border-gray-700 rounded-lg p-8 relative scale-105 shadow-lg" data-id="element-2109">
              <div className="absolute -top-4 -right-4 bg-gray-800 text-white px-4 py-2 text-sm font-bold rounded-lg transform rotate-6" data-id="element-2110">
                BEST VALUE
              </div>
              <div className="flex justify-center mb-6" data-id="element-2111">
                <div className="w-16 h-16 border-2 border-gray-700 rounded-full flex items-center justify-center" data-id="element-2112">
                  <Clock size={32} className="text-gray-700" data-id="element-2113" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-center text-gray-800 mb-2" data-id="element-2114">
                Founder's Offer
              </h3>
              <p className="text-center text-gray-600 mb-4" data-id="element-2115">
                🔥 Available Until Dec 31, 2024
              </p>
              <div className="text-center mb-6" data-id="element-2116">
                <p className="text-3xl font-bold text-gray-800" data-id="element-2117">₦20,000</p>
                <p className="text-gray-600" data-id="element-2118">per year</p>
              </div>
              <ul className="space-y-3 mb-8" data-id="element-2119">
                <li className="flex items-start" data-id="element-2120">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-2121" />
                  <span className="text-gray-600" data-id="element-2122">
                    Masterminds & handholding
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2123">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-2124" />
                  <span className="text-gray-600" data-id="element-2125">
                    AI Tools Catalogue + Resource Hub
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2126">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-2127" />
                  <span className="text-gray-600" data-id="element-2128">
                    Free Virtual Networking Salons
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2129">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-2130" />
                  <span className="text-gray-600" data-id="element-2131">Discounted Live Events</span>
                </li>
                <li className="flex items-start" data-id="element-2132">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-2133" />
                  <span className="text-gray-600" data-id="element-2134">Exclusive Opportunities</span>
                </li>
              </ul>
              <div className="bg-gray-100 text-center p-3 rounded-lg mb-6" data-id="element-2135">
                <span className="font-medium text-gray-700" data-id="element-2136">
                  Bonus: Subscription officially starts Jan 1, 2025 (December
                  free!)
                </span>
              </div>
              <Button className="w-full" data-id="element-2137">Join Now at ₦20,000</Button>
            </div>
            {/* Standard Membership */}
            <div className="border-2 border-gray-300 rounded-lg p-6 relative" data-id="element-2138">
              <div className="absolute top-0 right-0 bg-gray-600 text-white px-3 py-1 text-sm font-bold rounded-bl-lg" data-id="element-2139">
                REGULAR PRICE
              </div>
              <div className="flex justify-center mb-6" data-id="element-2140">
                <div className="w-16 h-16 border-2 border-gray-400 rounded-full flex items-center justify-center" data-id="element-2141">
                  <Users size={32} className="text-gray-700" data-id="element-2142" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-center text-gray-800 mb-2" data-id="element-2143">
                Standard Membership
              </h3>
              <p className="text-center text-gray-600 mb-4" data-id="element-2144">
                📌 From Jan 1, 2025
              </p>
              <div className="text-center mb-6" data-id="element-2145">
                <p className="text-3xl font-bold text-gray-800" data-id="element-2146">₦50,000</p>
                <p className="text-gray-600" data-id="element-2147">per year</p>
              </div>
              <ul className="space-y-3 mb-8" data-id="element-2148">
                <li className="flex items-start" data-id="element-2149">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-2150" />
                  <span className="text-gray-600" data-id="element-2151">
                    Masterminds & handholding
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2152">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-2153" />
                  <span className="text-gray-600" data-id="element-2154">
                    AI Tools Catalogue + Resource Hub
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2155">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-2156" />
                  <span className="text-gray-600" data-id="element-2157">
                    Free Virtual Networking Salons
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2158">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-2159" />
                  <span className="text-gray-600" data-id="element-2160">Discounted Live Events</span>
                </li>
                <li className="flex items-start" data-id="element-2161">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-2162" />
                  <span className="text-gray-600" data-id="element-2163">Exclusive Opportunities</span>
                </li>
              </ul>
              <div className="bg-gray-100 text-center p-3 rounded-lg mb-6 invisible" data-id="element-2164">
                <span data-id="element-2165">Spacer</span>
              </div>
              <Button variant="outline" className="w-full" data-id="element-2166">
                Join for ₦50,000
              </Button>
            </div>
          </div>
        </div>
      </section>
      {/* Final CTA */}
      <section className="py-20 bg-gray-50" data-id="element-2167">
        <div className="container mx-auto px-4 text-center" data-id="element-2168">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-8 max-w-3xl mx-auto" data-id="element-2169">
            Stop Collecting Contacts. Start Building Connections That Change
            Your Future.
          </h2>
          <Button className="text-lg px-8 py-4" data-id="element-2170">
            Join Now for ₦20,000 (Founder's Rate)
          </Button>
          <p className="mt-6 text-gray-600" data-id="element-2171">
            Offer ends December 31, 2024. Regular price ₦50,000/year from
            January 1, 2025.
          </p>
        </div>
      </section>
    </div>;
};